module.exports = __webpack_public_path__ + "img/peacockbutterfly.6d9909d8.png";